export default __webpack_public_path__ + "62c9deb78b4f9b1f9b07c586c572d345.png";